// @flow

import { bind } from '@ta/common.api';
import DataCacher from '@ta/common.data-cacher';
import * as React from 'react';
import { featureIsEnabled } from '@ta/common.features';

type Props = {|
  loading: boolean,
  links: any,
  activeLinkId: ?string,
  extendedQuickLinks: any,
  isGeoScoped: boolean,
|};

const getNavApiParams = state => {
  const { initialServletName, device } = state.meta;
  const { locale } = state.i18n;
  const { latitude, longitude, searchNearby, geo, detail } = state.route;
  const viewportCategory =
    state.meta.forceFullSite && !featureIsEnabled('quicklinks_sorting_model')
      ? 'DESKTOP'
      : device.viewportCategory;

  const paramMap = {
    servlet: initialServletName,
    locale,
    geoId: geo,
    detailId: detail,
    viewportCategory,
    latitude,
    longitude,
    searchNearby,
  };

  // Filter out null and undefined values
  const filteredParams = {};
  Object.keys(paramMap).forEach(key => {
    if (paramMap[key] !== null && typeof paramMap[key] !== 'undefined') {
      filteredParams[key] = paramMap[key];
    }
  });

  return new URLSearchParams(filteredParams);
};

/** Calls the brand/navLinks API endpoint and feeds the data into a given component. Used for global nav and quick links. */
const GlobalNavApiBinding = (WrappedComponent: React.ComponentType<any>) =>
  bind<Props, {||}, _, _, _, _>((state, stage) => {
    const navApiCall = stage(`/data/1.0/brand/navLinks?${getNavApiParams(state).toString()}`);

    return () => {
      const { data, loading } = navApiCall.get();
      const links = data ? data.links : null;
      const activeLinkId = data ? data.activeLinkId : null;
      const isGeoScoped = data ? data.isGeoScoped : false;
      const extendedQuickLinks = data ? data.isQuickLinksMoreNewLine : false;

      return {
        loading,
        links,
        activeLinkId,
        extendedQuickLinks,
        isGeoScoped,
      };
    };
  })(DataCacher()(WrappedComponent));

export default GlobalNavApiBinding;
